import { useSelector } from 'react-redux';
import {
  brandSelector,
  channelSelector,
  languageSelector,
} from '../../redux/reducers/app/params';
import { contentAPIPrefixSelector } from '../../redux/reducers/app/configuration';
import { useMemo } from 'react';

export const useCommonQueryParams = () => {
  const language = useSelector(languageSelector);
  const brand = useSelector(brandSelector);
  const channel = useSelector(channelSelector);
  const contentAPIPrefix = useSelector(contentAPIPrefixSelector);

  return useMemo(
    () => ({
      language,
      brand,
      channel,
      contentAPIPrefix,
    }),
    [language, brand, channel, contentAPIPrefix]
  );
};
